import {
  getdashbordById,
  getAlldashbordsbyBot,updateUtteranceDash} from '@/api/dashbord.service.js'
import {
  getBotById
} from '@/api/bot.service.js'

export default {
  state: {
    dashbord: {},
    dashbords: [],
    dashbordsPub: []
  },
  getters: {
    getdashbord(state) {
      return state.dashbord
    },
    getAlldashbord(state) {
      return state.dashbords
    }
  },
  mutations: {

    setAlldashbords(state, dashbords) {
      state.dashbords = dashbords
    },
    setdashbord(state, dashbord) {
      state.dashbord = dashbord
    }
  },
  actions: {
    async setAlldashbords(context, id) {
      console.log("test store dash ", id)
      let dashbords = await getAlldashbordsbyBot(id)
      console.log("test dasbords",dashbords)

      context.commit('setAlldashbords', dashbords)
    },
    async updateUtteranceDash(context, utt){
      let upUtterance = await updateUtteranceDash(utt)
      context.commit('updateUtteranceDash', upUtterance)
    },

 



  }
}



// WEBPACK FOOTER //
// ./src/store/dashbord.store.js